import { store } from '@/helper/store';
import { computed } from 'vue';

export var fieldFactory = (name, storeId) => {
    return computed({
        get() {
            return store.value.find((object) => {
                return object.id === storeId
            })[name]
        },
        set(newValue) {
            store.value.find((object) => {
                return object.id === storeId
            })[name] = newValue;
        }
    })
}
